import { Fragment } from 'react'
import moment from 'moment'
import { APP_LANGUAGE } from '../../localized-urls'

export default function DateFormat({ date, format = 'll' }) {
  const IS_UTC = date && typeof date === 'string' ? date.indexOf('T') !== -1 : true

  return (
    <Fragment>
      {
        date ? (IS_UTC ? moment(date).locale(APP_LANGUAGE).utc().format(format) : moment(date).locale(APP_LANGUAGE).format(format)) : ''
      }
    </Fragment>
  )
}
